// extracted by mini-css-extract-plugin
export default {"chart":"TopCountry_chart__ivKU2"};